import { doInteraction } from './Analytics';
export function selectionTableLocation({ locationAbbr }) {
    doInteraction(`DASH SHPE|TABLE, LOCATION, ${locationAbbr}`);
}
export function selectTableSubQuestion({ questionId, subQuestionId }) {
    doInteraction(`DASH SHPE|TABLE, SUBQ, ${questionId}, ${subQuestionId}`);
}
export function selectTableReturn() {
    doInteraction(`DASH SHPE|TABLE, Return`);
}